import styled, { css } from 'styled-components';
import { FInter} from '@brg/ui';
import {LayoutConst} from "../../core";

export const SendProjectButton = styled(FInter.TextBoldFlex)<{isGreen?: boolean, c?: string, color?: string, hoverC?: string, r?:string, mt?: string, disabled?: boolean, width?: number, fullWidth?: boolean}>`
  /* Gallllery/Black */
  background: ${({ theme, isGreen, c }) => c ? c : isGreen ? theme.sendProjectsModal.buttons.send.greenBg : theme.sendProjectsModal.buttons.send.bg};
  border: 1px solid ${p => p.c ?? (p?.isGreen ?  p.theme.sendProjectsModal.buttons.send.greenBg : p.theme.sendProjectsModal.buttons.send.bg)};
  color: ${p => p.color ?? (p?.isGreen ? p.theme.sendProjectsModal.buttons.send.colorGreen : p.theme.sendProjectsModal.buttons.send.color)};
  border-radius: ${p => p.r ? `${p.r}px` : '3px'};
  margin-top: ${p => p.mt ? `-${p.mt}px` : "0"};
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  font-weight: 700;

  span {
    margin-left: 8px;
  }

  ${p => p?.width ? css`
    width: ${p?.width}px;
  ` : 
  css`
  min-width: 240px;
  max-width: 320px;
  `};

  ${p => p?.fullWidth ? css`
  width: 100%;
  max-width: 100%;
` : null};

  padding: 0 8px;
  height: 48px;
  cursor: pointer;
  align-content: center;
  justify-content: center;
  align-items: center;
  transition: all 0.5s;
  ${p => p?.disabled ? css`
    pointer-events: none;
    background-color: ${p => p.theme.sendProjectsModal.buttons.send.disable};
    color: ${p => p.theme.sendProjectsModal.buttons.send.disableClr};
    border-color: transparent;
  ` : css``};

  &:hover {
    background-color: ${p => !!p?.c ? p?.c : (p.isGreen ? p.theme.sendProjectsModal.buttons.send.greenBg :  p.theme.sendProjectsModal.buttons.send.hoverBg)};
    transition: background-color 0.5s;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
  }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
    max-width: none;
    min-width: auto;
    width: 100%;
    height: 46px;
    font-weight: 600;
    
    &:not(:first-child) {
      margin-left: 0px;
      margin-top: 24px;
      transition: margin-top unset;
    }
  }
`;

export const SubmitProjectButton = styled.button<{isGreen?: boolean, c?: string, r?:string, mt?: string, mr?: string}>`
  /* Gallllery/Black */
  background: ${p => p.c ?? (p?.isGreen ? p.theme.sendProjectsModal.buttons.send.greenBg : p.theme.sendProjectsModal.buttons.send.bg)};
  border: 1px solid ${p => p.c ??(p?.isGreen ? p.theme.sendProjectsModal.buttons.send.greenBg : p.theme.sendProjectsModal.buttons.send.bg)};
  color: ${p => p?.isGreen ? p.theme.sendProjectsModal.buttons.send.colorGreen : p.theme.sendProjectsModal.buttons.send.color};
  border-radius: ${p => p.r ? `${p.r}px` : '3px'};
  margin-top: ${p => p.mt ? `-${p.mt}px` : "0"};
  margin-right: ${p => p.mr ? `${p.mr}px` : "0"};
  font-size: 17px;
  line-height: 22px;
  font-weight: 700;
  min-width: 240px;
  max-width: 320px;
  padding: 0 8px;
  height: 48px;
  cursor: pointer;
  align-content: center;
  justify-content: center;
  align-items: center;
  transition: all 0.5s;
  &:hover{
    background-color: ${(p) => p?.isGreen ? p.theme.sendProjectsModal.buttons.send.greenBgHover : p.theme.sendProjectsModal.buttons.send.hoverBg};
    transition: background-color 0.5s;
  }
  &:disabled {
    background: ${(p) => p.theme.sendProjectsModal.buttons.send.disable};
    color: ${(p) => p.theme.sendProjectsModal.buttons.send.disableClr};
    border-color: transparent;
  }
`;import styled, { css } from 'styled-components';
import { FInter} from '@brg/ui';
import {LayoutConst} from "../../core";

export const SendProjectButton = styled(FInter.TextBoldFlex)<{isGreen?: boolean, c?: string, color?: string, hoverC?: string, r?:string, mt?: string, disabled?: boolean, width?: number, fullWidth?: boolean}>`
  /* Gallllery/Black */
  background: ${({ theme, isGreen, c }) => c ? c : isGreen ? theme.sendProjectsModal.buttons.send.greenBg : theme.sendProjectsModal.buttons.send.bg};
  border: 1px solid ${p => p.c ?? (p?.isGreen ?  p.theme.sendProjectsModal.buttons.send.greenBg : p.theme.sendProjectsModal.buttons.send.bg)};
  color: ${p => p.color ?? (p?.isGreen ? p.theme.sendProjectsModal.buttons.send.colorGreen : p.theme.sendProjectsModal.buttons.send.color)};
  border-radius: ${p => p.r ? `${p.r}px` : '3px'};
  margin-top: ${p => p.mt ? `-${p.mt}px` : "0"};
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  font-weight: 700;

  span {
    margin-left: 8px;
  }

  ${p => p?.width ? css`
    width: ${p?.width}px;
  ` : 
  css`
  min-width: 240px;
  max-width: 320px;
  `};

  ${p => p?.fullWidth ? css`
  width: 100%;
  max-width: 100%;
` : null};

  padding: 0 8px;
  height: 48px;
  cursor: pointer;
  align-content: center;
  justify-content: center;
  align-items: center;
  transition: all 0.5s;
  ${p => p?.disabled ? css`
    pointer-events: none;
    background-color: ${p => p.theme.sendProjectsModal.buttons.send.disable};
    color: ${p => p.theme.sendProjectsModal.buttons.send.disableClr};
    border-color: transparent;
  ` : css``};

  &:hover {
    background-color: ${p => !!p?.c ? p?.c : (p.isGreen ? p.theme.sendProjectsModal.buttons.send.greenBg :  p.theme.sendProjectsModal.buttons.send.hoverBg)};
    transition: background-color 0.5s;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
  }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
    max-width: none;
    min-width: auto;
    width: 100%;
    height: 46px;
    font-weight: 600;
    
    &:not(:first-child) {
      margin-left: 0px;
      margin-top: 24px;
      transition: margin-top unset;
    }
  }
`;

export const SubmitProjectButton = styled.button<{isGreen?: boolean, c?: string, r?:string, mt?: string, mr?: string}>`
  /* Gallllery/Black */
  background: ${p => p.c ?? (p?.isGreen ? p.theme.sendProjectsModal.buttons.send.greenBg : p.theme.sendProjectsModal.buttons.send.bg)};
  border: 1px solid ${p => p.c ??(p?.isGreen ? p.theme.sendProjectsModal.buttons.send.greenBg : p.theme.sendProjectsModal.buttons.send.bg)};
  color: ${p => p?.isGreen ? p.theme.sendProjectsModal.buttons.send.colorGreen : p.theme.sendProjectsModal.buttons.send.color};
  border-radius: ${p => p.r ? `${p.r}px` : '3px'};
  margin-top: ${p => p.mt ? `-${p.mt}px` : "0"};
  margin-right: ${p => p.mr ? `${p.mr}px` : "0"};
  font-size: 17px;
  line-height: 22px;
  font-weight: 700;
  min-width: 240px;
  max-width: 320px;
  padding: 0 8px;
  height: 48px;
  cursor: pointer;
  align-content: center;
  justify-content: center;
  align-items: center;
  transition: all 0.5s;
  &:hover{
    background-color: ${(p) => p?.isGreen ? p.theme.sendProjectsModal.buttons.send.greenBgHover : p.theme.sendProjectsModal.buttons.send.hoverBg};
    transition: background-color 0.5s;
  }
  &:disabled {
    background: ${(p) => p.theme.sendProjectsModal.buttons.send.disable};
    color: ${(p) => p.theme.sendProjectsModal.buttons.send.disableClr};
    border-color: transparent;
  }
`;